import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

type PricingCalculatorCtaButtonProps = {
  linkHref: string
  trackClickEvent: () => void
  startButtonText: string
  continueButtonText: string
  hasSelectedJurisdictions: boolean
}

export const PricingCalculatorCtaButton: FC<PricingCalculatorCtaButtonProps> = ({
  linkHref,
  trackClickEvent,
  startButtonText,
  continueButtonText,
  hasSelectedJurisdictions,
}) => {
  const {t} = useTranslation()

  return (
    <Link href={linkHref} onClick={trackClickEvent}>
      <Button
        variant={ButtonVariant.primary}
        fullWidth
        type="button"
        icon={<ArrowIcon color={theme.palette.text.white} />}
        isIconAnimated
      >
        {hasSelectedJurisdictions ? t(continueButtonText) : t(startButtonText)}
      </Button>
    </Link>
  )
}
